import React from "react";
import { REACT_FLOW_CHART } from "@mrblenny/react-flow-chart";
import { Row, Col } from "reactstrap";
import "../node-inner-custom/nodeInnerCustom.css";
import { DEFAULT_NODE_ICON, SHORT_NODE_NAME } from "../../../constants";
import NodeIcon from "../../node-icons";
import { NODE_NAMES } from "../../../utils/nodeTypes";
import T from "../../atoms/translate";

export function NodeItem({ type, ports, properties }) {
  let defaultIcon = DEFAULT_NODE_ICON;
  // node style
  let defaultStyle = {
    width: "160px",
    height: "50px",
    cursor: "move",
    backgroundColor: "#d6e9f2",
    borderRadius: "8px",
    color: "black",
    marginTop: "15px"
  };
  //
  // const [popoverOpen, setPopoverOpen] = useState(false);
  // const togglePopover = () => {
  //   setPopoverOpen(!popoverOpen);
  // };
  //
  const textStyle = {
    //estilo del texto interior del nodo
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
    width: "85%",
    height: "80%",
    borderRadius: "8px",
    margin: "7px 13px 7px 13px"
  };
  //
  //
  if (properties && properties.style && properties.style.icon) {
    defaultIcon =
      typeof properties.style.icon === "string"
        ? properties.style.icon
        : properties.style.icon.bar;
    if (properties.style.backgroundColor)
      defaultStyle.backgroundColor = properties.style.backgroundColor;
    if (properties.style.textStyle && properties.style.textStyle.color) {
      textStyle.color = properties.style.textStyle.color;
      if (properties.style.textStyle.backgroundColor) {
        textStyle.backgroundColor = properties.style.textStyle.backgroundColor;
      }
    }
  }
  return (
    <Row
      className="mx-0 mb-3 node-item"
      draggable={true}
      onDragStart={event => {
        event.dataTransfer.setData(
          REACT_FLOW_CHART,
          JSON.stringify({ type, ports, properties })
        );
      }}
    >
      {defaultIcon !== "none" ? (
        <Col xs="4" className="px-auto py-2 node-item-icon">
          <NodeIcon
            draggable={false}
            icon={defaultIcon}
            width={30}
            alt={`icon-${SHORT_NODE_NAME(type)}`}
          />
        </Col>
      ) : null}
      <Col xs={defaultIcon !== "none" ? "8" : "12"} className="node-item-text">
        <span>
          <T i18nKey={NODE_NAMES[type].name} />
        </span>
      </Col>
    </Row>
  );
}
